<template lang="pug">
    div
        component(
            :is="logoOptions.is"
            :class="logoOptions.class"
            class="fill-current w-full h-auto"
        )
</template>

<script>
import { sameDayShippingDisplayMixin } from '@/helpers/shipping'
const SameDayIcon = () =>
    import(/* webpackChunkName: "same-day-icon" */ '@/assets/shipping/same-day-icon?inline')
const SameDayQuickShipLogo = () =>
    import(
        /* webpackChunkName: "same-day-quickship-logo" */ '@/assets/shipping/same-day-quickship?inline'
    )
const SameDayRapidShipLogo = () =>
    import(
        /* webpackChunkName: "same-day-rapidship-logo" */ '@/assets/shipping/same-day-rapidship?inline'
    )

export default {
    name: 'SameDayShippingLogo',
    components: {
        SameDayIcon,
        SameDayQuickShipLogo,
        SameDayRapidShipLogo,
    },
    mixins: [sameDayShippingDisplayMixin],
    props: {
        isIcon: {
            type: Boolean,
            default: false,
        },
        isWhite: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        logoOptions() {
            const obj = {
                is:
                    this.$config.runtime.theme.sameDayShipping.mode === 'RAPIDSHIP'
                        ? 'SameDayRapidShipLogo'
                        : 'SameDayQuickShipLogo',
                class: [],
            }

            if (this.isWhite) obj.class.push('text-white')
            else obj.class.push(this.sameDayShippingTextColor)

            if (this.isIcon) obj.is = 'SameDayIcon'

            return obj
        },
    },
}
</script>
